import React, { PropTypes } from 'react';

const SubcategoryIcon = ({ subcat }) => {
  let subcatIcon = '';

  try {
    subcatIcon = require(`assets/images/icons/pap/PAP_cat_icon_${subcat.slug}.svg`);
  } catch (e) {
    subcatIcon = require('assets/images/icons/pap/PAP_cat_icon_logo-design.svg');
  }

  return (<i className="icon" dangerouslySetInnerHTML={{ __html: subcatIcon }} />);
};

SubcategoryIcon.propTypes = {
  subcat: PropTypes.object.isRequired,
};

export default SubcategoryIcon;



// WEBPACK FOOTER //
// ./common/components/subcategory_icon.jsx